import { useEffect, useRef } from "react";
import { FeedbackService } from "../services/feedbackService";

export const useRealtimeFeedback = (onInsert, onUpdate, onDelete) => {
  const subscriptionRef = useRef(null);

  useEffect(() => {
    // Subscribe to feedback changes
    subscriptionRef.current = FeedbackService.subscribeFeedback(
      (newFeedback) => {
        if (onInsert) onInsert(newFeedback);
      },
      (updatedFeedback) => {
        if (onUpdate) onUpdate(updatedFeedback);
      },
      (deletedId) => {
        if (onDelete) onDelete(deletedId);
      }
    );

    // Cleanup subscription on unmount
    return () => {
      if (subscriptionRef.current) {
        FeedbackService.unsubscribeFeedback(subscriptionRef.current);
      }
    };
  }, [onInsert, onUpdate, onDelete]);
};